
const _ = require('lodash');

const dataTable = require('./definition');

_.extend(dataTable.defaults, {
	autoWidth: false,
});
